<script>
  import * as THREE from "three";
  import { onMount, getContext } from "svelte";
  import viewport from "../stores/viewport.js";
  import { time } from "../stores/global.js";
  import vertexShader from "../shaders/starfield-vertex.glsl";
  import fragmentShader from "../shaders/starfield-fragment.glsl";

  export let audioData;
  export let starfieldGroup;
  export let count;

  const { NEAR, FAR, DEPTH, PIXEL_RATIO } = getContext("Universe");

  const nPointsGeometry = function (count) {
    const positions = new Float32Array(count * 3);
    const indices = new Float32Array(count);
    for (let i = 0; i < count; i++) {
      const index = i * 3;
      positions[index] = 0;
      positions[index + 1] = 0;
      positions[index + 2] = 0;
      indices[i] = i;
    }
    const geometry = new THREE.BufferGeometry();
    geometry.setAttribute("position", new THREE.BufferAttribute(positions, 3));
    geometry.setAttribute("vIndex", new THREE.BufferAttribute(indices, 1));
    return geometry;
  };

  const starfield = new THREE.Group();
  const geometry = nPointsGeometry(count);

  const uniforms = {
    uTime: {
      value: $time,
    },
    uResolution: {
      value: {
        x: $viewport.width,
        y: $viewport.height,
      },
    },
    uPixelRatio: {
      value: PIXEL_RATIO,
    },
    uOpacity: {
      value: 1.0,
    },
    uCount: {
      value: count,
    },
    uAudioData: {
      type: "fv",
      value: audioData || new Float32Array(64),
    },
  };

  const material = new THREE.ShaderMaterial({
    transparent: true,
    uniforms: uniforms,
    vertexShader: vertexShader,
    fragmentShader: fragmentShader,
  });
  const mesh = new THREE.Points(geometry, material);

  starfield.add(mesh);
  starfield.position.set(0, 0, 0);

  onMount(() => {
    starfieldGroup.add(starfield);
  });

  $: {
    material.uniforms.uTime.value = $time;
    if (audioData) {
      material.uniforms.uAudioData.value = audioData.map((e, i) => {
        const prevVal =
          i > 0
            ? material.uniforms.uAudioData.value[i - 1]
            : material.uniforms.uAudioData.value[0];
        return 0.01 * Math.log(1 + Math.max(e, 0)) + 0.98 * prevVal;
      });
    }
  }

  $: {
    material.uniforms.uResolution.value = {
      x: $viewport.width,
      y: $viewport.height,
    };
  }
</script>
